module.exports = __webpack_public_path__ + "img/warning_red.01c31115.svg";